module.exports = __webpack_public_path__ + "static/media/photoDartLogo.8c2ae1dc.svg";